export type RootLandingRoute = 'loading' | 'dashboard' | 'public';

type RootLandingState = {
  authLoading: boolean;
  isAuthenticated: boolean;
};

/**
 * Root route waits for persisted authentication to hydrate so returning users
 * never see public marketing content flash before entering their workspace.
 */
export const resolveRootLandingRoute = ({
  authLoading,
  isAuthenticated,
}: RootLandingState): RootLandingRoute => {
  if (authLoading) return 'loading';
  return isAuthenticated ? 'dashboard' : 'public';
};
